<div class="control-panel">
  <select
    *ngIf="buildingList.length >= 1"
    [(ngModel)]="currentBuilding"
    (change)="onBuildingChange($event)"
    class="control-select">
    <option *ngFor="let b of buildingList" [value]="b">{{b}}</option>
  </select>

  <select
    *ngIf="floorList.length >= 1"
    [(ngModel)]="currentFloor"
    (change)="onFloorChange($event)"
    class="control-select">
    <option *ngFor="let f of floorList" [value]="f">{{f}}</option>
  </select>

  <button
    (click)="onTopView3D()"
    class="control-btn primary-btn">
    <i class="fa fa-eye"></i>
    {{ 'plant3dmap.default_view' | translate }}
  </button>

  <!-- 多選顯示選項下拉選單 -->
  <div class="multi-select-dropdown">
    <button
      class="control-btn toggle-btn dropdown-trigger"
      type="button"
      (click)="toggleDropdown()"
      [class.active]="dropdownOpen">
      <i class="fa fa-eye"></i>
      {{ 'plant3dmap.display_options' | translate }}
      <i class="fa fa-chevron-down" [class.rotated]="dropdownOpen"></i>
    </button>
    <div class="dropdown-content" [class.show]="dropdownOpen">
      <label *ngFor="let option of displayOptions" class="dropdown-option">
        <input
          type="checkbox"
          [(ngModel)]="option.checked"
          (change)="onDisplayOptionChange(option)">
        <span>{{ option.label }}</span>
      </label>
    </div>
  </div>

  <!-- 相機控制按鈕組 -->
  <div class="camera-controls">
    <div class="camera-control-group">
      <span class="control-group-label">{{ 'plant3dmap.horizontal_move' | translate }}：</span>
      <button (click)="panCamera('left')" class="control-btn camera-btn">
        <i class="fa fa-arrow-left"></i>
      </button>
      <button (click)="panCamera('right')" class="control-btn camera-btn">
        <i class="fa fa-arrow-right"></i>
      </button>
      <button (click)="panCamera('up')" class="control-btn camera-btn">
        <i class="fa fa-arrow-up"></i>
      </button>
      <button (click)="panCamera('down')" class="control-btn camera-btn">
        <i class="fa fa-arrow-down"></i>
      </button>
    </div>

    <div class="camera-control-group">
      <span class="control-group-label">{{ 'plant3dmap.zoom' | translate }}：</span>
      <button (click)="zoomCamera('in')" class="control-btn camera-btn">
        <i class="fa fa-plus"></i>
      </button>
      <button (click)="zoomCamera('out')" class="control-btn camera-btn">
        <i class="fa fa-minus"></i>
      </button>
    </div>
  </div>
</div>

<div class="main-content">
  <div class="renderer-area">
    <div #rendererContainer class="renderer-container"></div>
  </div>
  
  <!-- 右側資訊面板 -->
  <div class="info-panel" [class.show]="selectedObjectInfo">
    <div class="info-panel-header">
      <h3 class="info-title">{{ 'plant3dmap.object_info' | translate }}</h3>
      <button class="close-btn" (click)="clearSelectedObject()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    
    <div class="info-content" *ngIf="selectedObjectInfo">
      <div class="info-section">
        <h4>{{ 'plant3dmap.basic_info' | translate }}</h4>
        <div class="info-item">
          <label>{{ 'plant3dmap.object_name' | translate }}：</label>
          <span>{{ selectedObjectInfo.name }}</span>
        </div>
        <div class="info-item">
          <label>{{ 'plant3dmap.object_type' | translate }}：</label>
          <span>{{ selectedObjectInfo.type }}</span>
        </div>
        <div class="info-item">
          <label>{{ 'plant3dmap.floor' | translate }}：</label>
          <span>{{ selectedObjectInfo.floor }}</span>
        </div>
        <div class="info-item" *ngIf="selectedObjectInfo.status">
          <label>{{ 'plant3dmap.status' | translate }}：</label>
          <span class="status" [class]="selectedObjectInfo.status">{{ selectedObjectInfo.status }}</span>
        </div>
      </div>

      <div class="info-section" *ngIf="selectedObjectInfo.chemicals && selectedObjectInfo.chemicals.length > 0">
        <h4>{{ 'plant3dmap.chemical_list' | translate }}</h4>
        <div class="chemical-list">
          <div class="chemical-item" *ngFor="let chemical of selectedObjectInfo.chemicals">
            <div class="chemical-header">
              <span class="chemical-name">{{ chemical.name }}</span>
              <span class="danger-level" [class]="chemical.dangerLevel">
                {{ chemical.dangerLevel | uppercase }}
              </span>
            </div>
            <div class="chemical-details">
              <div class="chemical-detail">
                <label>{{ 'plant3dmap.usage' | translate }}：</label>
                <span>{{ chemical.usage }}</span>
              </div>
              <div class="chemical-detail">
                <label>{{ 'plant3dmap.quantity' | translate }}：</label>
                <span>{{ chemical.quantity }}</span>
              </div>
              <div class="chemical-detail" *ngIf="chemical.location">
                <label>{{ 'plant3dmap.storage_location' | translate }}：</label>
                <span>{{ chemical.location }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-section" *ngIf="selectedObjectInfo.description">
        <h4>{{ 'plant3dmap.description' | translate }}</h4>
        <p class="description">{{ selectedObjectInfo.description }}</p>
      </div>
    </div>
  </div>
</div>

<div class="bottom-control-panel">
  <div class="device-selection-area">
    <div class="selection-group">
      <label class="selection-label" for="deviceSelect">{{ 'plant3dmap.select_device' | translate }}：</label>
      <select
        id="deviceSelect"
        [(ngModel)]="selectedDeviceId"
        (change)="onDeviceChange()"
        class="selection-dropdown">
        <option value="">{{ 'plant3dmap.please_select_device' | translate }}</option>
        <option *ngFor="let item of clickableItems" [value]="item.id">{{ item.name }}</option>
      </select>
    </div>

    <div class="selection-group" *ngIf="selectedDeviceId">
      <label class="selection-label" for="actionSelect">{{ 'plant3dmap.select_action' | translate }}：</label>
      <select
        id="actionSelect"
        [(ngModel)]="selectedAction"
        (change)="onActionChange()"
        class="selection-dropdown">
        <option value="">{{ 'plant3dmap.please_select_action' | translate }}</option>
        <option value="position">{{ 'plant3dmap.position_adjustment' | translate }}</option>
      </select>
    </div>

    <div class="device-controls" *ngIf="selectedDeviceId && selectedAction">
      <!-- 位置調整控制按鈕 -->
      <div class="control-group" *ngIf="selectedAction === 'position'">
        <span class="control-group-title">{{ 'plant3dmap.position_control' | translate }}：</span>
        <div class="control-buttons">
          <button (click)="moveSelectedItem('up')" class="device-control-btn">
            <i class="fa fa-arrow-up"></i> {{ 'plant3dmap.up' | translate }}
          </button>
          <button (click)="moveSelectedItem('down')" class="device-control-btn">
            <i class="fa fa-arrow-down"></i> {{ 'plant3dmap.down' | translate }}
          </button>
          <button (click)="moveSelectedItem('left')" class="device-control-btn">
            <i class="fa fa-arrow-left"></i> {{ 'plant3dmap.left' | translate }}
          </button>
          <button (click)="moveSelectedItem('right')" class="device-control-btn">
            <i class="fa fa-arrow-right"></i> {{ 'plant3dmap.right' | translate }}
          </button>
          <button (click)="moveSelectedItem('forward')" class="device-control-btn">
            <i class="fa fa-arrow-up"></i> {{ 'plant3dmap.high' | translate }}
          </button>
          <button (click)="moveSelectedItem('backward')" class="device-control-btn">
            <i class="fa fa-arrow-down"></i> {{ 'plant3dmap.low' | translate }}
          </button>
        </div>
      </div>

      <!-- 旋轉控制按鈕 -->
      <div class="control-group" *ngIf="selectedAction === 'position'">
        <span class="control-group-title">{{ 'plant3dmap.rotation_control' | translate }}：</span>
        <div class="control-buttons">
          <button (click)="rotateSelectedItem('cw')" class="device-control-btn">
            <i class="fa fa-rotate-right"></i> {{ 'plant3dmap.clockwise' | translate }}
          </button>
          <button (click)="rotateSelectedItem('ccw')" class="device-control-btn">
            <i class="fa fa-rotate-left"></i> {{ 'plant3dmap.counterclockwise' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
